import { Typography } from "@mui/material";

interface ChartTitleProps {
    text: string;
}

// Title above a waterfall chart. Its text may hold a line break; two lines are always reserved, so the
// charts of cards side by side line up whether their title takes one line or two.
export const ChartTitle: React.FC<ChartTitleProps> = ({ text }) => {
    return (
        <Typography fontSize="16px" fontWeight={600} lineHeight="20px" minHeight="40px" textAlign="center" sx={{ whiteSpace: "pre-line" }}>
            {text}
        </Typography>
    );
};
